import React from 'react';

import PropTypes from 'prop-types';

import Divider from '@adsk/alloy-react-divider';
import theme, { stylePropType, StyleProp } from '@adsk/alloy-react-theme';

type FooterProps = {
  style?: StyleProp;
  className?: string;
  children?: React.ReactNode;
};

const Footer = ({ style, className, children }: FooterProps) => {
  return (
    <>
      <Divider style={{ margin: '15px 0' }} />
      <div
        className={className}
        css={[
          {
            padding: `0 ${theme.spacing.M}px`,
            display: 'flex',
            flexFlow: 'row wrap',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
          },
          style,
        ]}
      >
        {children}
      </div>
    </>
  );
};

Footer.displayName = 'DatePickerFooter';

Footer.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Footer content */
  children: PropTypes.any,
};

export default Footer;
